document.addEventListener('DOMContentLoaded', function() {
    const burgerBtn = document.getElementById('birdy-burger-btn');
    const overlay = document.getElementById('birdy-overlay');
    const body = document.body;
    const logo = document.getElementById('birdy-logo'); // Select the logo

    burgerBtn.addEventListener('click', function() {
        overlay.classList.toggle('active');
        body.classList.toggle('no-scroll');

        // Toggle class on logo when menu is active
        if (overlay.classList.contains('active')) {
            logo.classList.add('menu-active'); // Add class
        } else {
            logo.classList.remove('menu-active'); // Remove class
        }
    });  

    var icons = document.querySelectorAll('#birdy-burger-btn');

    icons.forEach(function(icon) {
        icon.addEventListener('click', function() {
            this.classList.toggle('open');
        });
    });
});
